<fieldset>
    <div class="alert alert-warning" role="alert">
        {{'config.user.delete.confirm' | i18n}}
    </div>
</fieldset>
